import {GetB2BBeneficiaryStatusParams} from 'domain/usecases/others/selection-flow/b2b/get-b2b-beneficiary-status';
import {makeGetB2BBeneficiaryStatus} from 'main/factories/usecases/others/selection-flow/remote-b2b/get-b2b-beneficiary-status-factory';

export const getB2BBeneficiaryStatus = async (params: GetB2BBeneficiaryStatusParams) => {
	const {habilitado} = await makeGetB2BBeneficiaryStatus().get(params);
	return habilitado;
};
